module.exports = __webpack_public_path__ + "static/media/blue_arrow_left.99a20c86.svg";